export default defineNuxtRouteMiddleware(async (to) => {
  // Remove trailing slash from path (except for root path)
  if (to.path !== '/' && to.path.endsWith('/')) {
    const newPath = to.path.slice(0, -1)
    const newRoute = {
      path: newPath,
      query: to.query,
      hash: to.hash,
    }
    return navigateTo(newRoute, { redirectCode: 302 })
  }
})
